
interface IFiltro {
   id: string;
   descricao: string;
   apresentar: boolean;
}


export class Filtro implements IFiltro {

   id: string;
   descricao: string;
   apresentar: boolean;
   labelAtivo: string;
   limparFiltro: () => any;

   constructor(id: string, descricao: string, apresentar: boolean, labelAtivo: string, limparFiltro: () => any,
      _filtroRapido?: boolean, _icone?: any, _onClick?: () => any) {
      this.id = id;
      this.descricao = descricao;
      this.apresentar = apresentar;
      this.labelAtivo = labelAtivo;
      this.limparFiltro = limparFiltro;
   }

}

export class FiltroRapido implements IFiltro{
   id: string;
   icone: any;
   descricao: string;
   apresentar: boolean;
   onClick?: () => any;
   
   constructor(id: string, descricao: string, apresentar: boolean, icone: any, onClick: () => any) {
      this.id = id;
      this.descricao = descricao;
      this.apresentar = apresentar;
      this.icone = icone;
      this.onClick = onClick;
   }
}